import React from "react";
import SamagraMenu from "./SamagraMenu";
import { Outlet } from "react-router-dom";

const PSamagraLayout = () => {
    return (
        <>
            <div className="dflex gap-3" style={{position:"relative"}}> 
               
                <SamagraMenu />
                <div className="w-100 p-3"><Outlet/></div>
            </div>
        </>
    )
}
export default PSamagraLayout;